// extracted by mini-css-extract-plugin
module.exports = {"totalProducts":"TotalProducts_totalProducts__V8p5V"};